import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import { getPrograms } from '../../routes/UserAction';

import { domainUrl, domain, timeFormat, reduceText } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

export default function Programs() {
    const dispatch = useDispatch();

    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;


    const [programs, setPrograms] = useState([]);

    // const fetchPrograms = () => {
    //     dispatch(getPrograms())
    //     .then(response =>{
    //         let resData = response?.payload?.data;
    //         const editableData = resData?.map(o => ({ ...o }));
    //         setPrograms(editableData);
    //     })
    //     .catch((error) => {
    //         console.log(error)
    //     })
    // }

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        total: 0,
    });

    const fetchPrograms = (page = 1) => {
        dispatch(getPrograms({ page }))
        .then(response => {
            const resData = response?.payload;
            const isPaginated = !!resData?.meta;

            setPrograms(resData.data);
            setPagination(resData.meta);
        })
        .catch(console.log);
    };

    const handlePageChange = (newPage) => {
        if (newPage !== pagination.current_page) {
            fetchPrograms(newPage);
        }
    };

    useEffect(() => {
        fetchPrograms();
    }, [])


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'program'}/>

        {/* <!-- Programs Start --> */}
        <div className="container-fluid courses overflow-hidden py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    {/* <h4 className="text-primary"> Our Courses</h4> */}
                    <h4 className="" style={{color: 'gold'}}> EmyPrograms</h4>
                    <h1 className="display-4 text-white mb-4">Our Programs</h1>
                    {/* <p className="text-white mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                    </p> */}
                </div>
                <div className="row gy-4 gx-0 justify-content-center">
                    {programs?.filter(el => el.type == 1)?.length ? programs.filter(el => el.type == 1).map((row) => (
                        <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="courses-item">
                                <div className="courses-item-inner p-4" style={{ 
                                    // backgroundImage: "url('./assets/img/emy.png')",
                                    backgroundImage: `url(${row.image ? domain+row.image : "./assets/img/emy.png"})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center',
                                    // backgroundSize: 'cover',
                                    backgroundSize: 'contain',
                                }}>
                                    <div className="d-flex justify-content-between mb-4">
                                        {/* <div className="courses-icon-img p-3">
                                            <img src="./assets/img/soft.png" className="img-fluid" alt=""/>
                                        </div> */}
                                        <div className="data-info d-flex flex-column">
                                            {/* <div className="courses-trainer d-flex align-items-center mb-1">
                                                <div className="me-2" style={{width: '25px', height: '25px'}}>
                                                    <img src="./assets/img/soft.png" className="img-fluid" alt=""/>
                                                </div>
                                                <p className="mb-0">Paul Flavius</p>
                                            </div> */}
                                            <div className="courses-date">
                                                <p className="mb-1">Posted: {timeFormat(row.created_at)}</p>
                                                <p className="mb-0">Start: {row.schedules?.length ? `${row.schedules[0].start_at} - ${row.schedules[0].end_at}` : 'No schedule'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="#" className="d-inline-block h4 mb-3">{row.name}</a>
                                    <p className="mb-4">
                                        {row.about? reduceText(row.about, 200, '...'): ''}
                                    </p>
                                    <Link to={row.uuid? `/program?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Read More</span></Link>
                                </div>
                            </div>
                        </div>
                    )) : <></>}
                    
                    {/* <div className="col-12 text-center wow fadeInUp" data-wow-delay="0.2s">
                    <Link to={'/programs'} className="btn btn-primary py-3 px-5"> <span>More Programs</span></Link>
                    </div> */}
                </div>
            </div>

            {pagination.last_page > 1 && (
                <div className="text-center mt-4">
                    {[...Array(pagination.last_page)].map((_, i) => (
                        <button
                            key={i}
                            onClick={() => handlePageChange(i + 1)}
                            className={`btn ${pagination.current_page === i + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
            )}
        </div>
        {/* <!-- Programs End --> */}

        <Footer/>
        </>
    );
}
